import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ROUTES } from "../../lib/routes";
import { useUserDetails } from "@/redux/function";

const PublicRoute = () => {
  const userData = useUserDetails();
  const accessToken = userData?.access;
  const location = useLocation();

  const pathname = location.pathname;

  const redirectParam = new URLSearchParams(location.search).get("redirect");

  if (redirectParam) {
    return <Outlet />;
  }

  const restrictedPaths = [
    ROUTES.LOGIN.BASE,
  ];

  const isRestricted = restrictedPaths.includes(pathname);

  if (accessToken && isRestricted) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
};

export default PublicRoute;
